import { render, staticRenderFns } from "./FocusKeywords.vue?vue&type=template&id=73afff10&scoped=true"
import script from "./FocusKeywords.vue?vue&type=script&lang=js"
export * from "./FocusKeywords.vue?vue&type=script&lang=js"
import style0 from "./FocusKeywords.vue?vue&type=style&index=0&id=73afff10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73afff10",
  null
  
)

export default component.exports